// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"6b6409e7","787":"d963cb5c"}[chunkId] + ".chunk.js";
};